import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import SidebarToggle_vue_vue_type_script_setup_true_lang_default from "./SidebarToggle.vue.script.js";
/* empty css                            */
//#region src/v2/components/sidebar/SidebarToggle.vue
var SidebarToggle_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SidebarToggle_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-4a35414a"]]);
//#endregion
export { SidebarToggle_default as default };

//# sourceMappingURL=SidebarToggle.vue.js.map